var map = {
	"./logoText_atlas.png": 79168,
	"./logoText_co3.png": 4384,
	"./logoText_corpsconnect.png": 12568,
	"./logoText_kasconnect.png": 65888,
	"./logoText_kiwanis.png": 34739,
	"./logoText_korponnect.png": 18820,
	"./logoText_landfrauen.png": 73719,
	"./logoText_metallverband.png": 81254,
	"./logoText_soroptimist.png": 19902,
	"./logoText_yoga.png": 59914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50276;